import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { COLORS } from 'constants/colorPicker';
import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  DialogActions,
  ListItemIcon,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import styles from './ChatFoldersModal.module.scss';
import { useSelectedContext } from 'context/contextSelector';

const ChatFoldersModal = ({ open, onClose, chatId }) => {
  const { chatFolders, appendChatsChatCategory } = useSelectedContext(
    (context) => context.messenger
  );
  const [selectedFolder, setSelectedFolder] = useState(null);

  const save = () => {
    if (selectedFolder) {
      appendChatsChatCategory([chatId], selectedFolder);
      onClose();
    }
  };

  const closeDialog = () => {
    setSelectedFolder(null);
    onClose();
  };

  return (
    <Dialog
      onClose={closeDialog}
      open={open}
      style={{ borderRadius: 12, padding: '0px 0px 0px 0px', overflow: 'auto' }}
      fullWidth
    >
      <DialogTitle className={styles.dialogTitle}>
        Folders
        <IconButton
          aria-label="close"
          onClick={closeDialog}
          sx={{
            position: 'absolute',
            right: 10,
            top: 14,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <h3 className={styles.subTitle}>My folders</h3>
        <List sx={{ width: '100%' }}>
          {chatFolders.map((folder) => (
            <ListItemButton
              sx={{ px: 0 }}
              onClick={() => setSelectedFolder(folder.id)}
              key={folder.id}
            >
              <ListItemAvatar>
                <Avatar sx={{ width: 48, height: 48 }} style={{ background: folder.color }}>
                  {COLORS.find((item) => item.color === folder.color)?.isDark ? (
                    <img
                      src="/images/chat/folder-icon-white.svg"
                      alt=""
                      style={{ width: 21, height: 15 }}
                    />
                  ) : (
                    <img
                      src="/images/chat/folder-icon.svg"
                      alt=""
                      style={{ width: 21, height: 15 }}
                    />
                  )}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={folder.name} />
              {selectedFolder === folder.id && (
                <ListItemIcon sx={{ minWidth: 'unset' }}>
                  <CheckIcon />
                </ListItemIcon>
              )}
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        {selectedFolder && <Button onClick={() => save()}>Add</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default ChatFoldersModal;
